export default __webpack_public_path__ + "55368ce7aa312e4b4f6b845602701a5f.png";